<template>
    <div class="form-field">
        <label :for="name">
          {{ label }}
          <span v-if="subtitle">{{ subtitle }}</span>
        </label>
        <input 
            :type="type"
            :name="name"
            :value="modelValue"
            @input="$emit('update:modelValue', $event.target.value)"
            @keyup="validate"
            :placeholder="placeholder ?? label"
        />
        <span class="error" v-if="showError">
          {{ error }}
        </span>
    </div>
</template>

<script>
export default {
  name: 'InputText',
  props: {
    type: {
        type: String,
        default: 'text',
    },
    error: {
      type: String,
    },
    pattern: {
      type: Boolean,
    },
    name: {
        type: String,
        required: true,
    },
    label: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
    },
    subtitle: {
      type: String
    },
    modelValue: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showError: false
    }
  },
  methods: {
    validate($event) {
      let isValid = true;
      if (this.pattern) {
        isValid = /^[a-zA-Z]\d{3}$/.test($event.target.value);
        this.showError = !isValid;
      }
    }
  }
}
</script>

<style scoped>

input {
  padding: 21px 18px 19px 18px;
  border-radius: 7px;
  border: solid 1px #dadde2;
  background-color: #fff;
  width: 100%;
  font-size: 1.6rem;
}

input:focus {
  outline: none;
  box-shadow:0px 0px 0px 3px #da503b inset;
}
</style>
